<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
     width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
  },
  // watch: {
     //chartdata: {
       //handler(val) {
       //  console.log(val)
         //this.renderChart(this.chartdata, this.options)
      // },
     //  deep: true
    // }
   //},
  mounted () {
    this.renderChart(this.chartData,{maintainAspectRatio:false,responsive: true,})
  }
}
</script>